import React, { useEffect } from 'react'

import Modal from '@f/components/Modal'
import CTA from '@f/elements/CTA'
import CookieModal from '@f/widgets/CookieModal'

const policyOptions = {
  essentials: 'es',
  statistic: 'st',
  functional: 'fu',
  marketing: 'ma'
}

const CookieBanner = props => {
  const COOKIEPOLICYCONFIG = 'cookie_policy_config'

  const handleCookieModalOpen = () => {
    const modal = new Modal()

    modal.openModal({
      component: <CookieModal />
    })

    props.closeBanner()
  }

  const saveAll = () => {
    _wt({
      category: 'form',
      action: 'submit',
      values: [
        {
          type: 'cookie',
          value: 'es,st,fu,ma'
        }
      ],
      location: 'banner-cookies'
    })

    window['🍪'].set(
      COOKIEPOLICYCONFIG,
      Object.values(policyOptions).join(','),
      3650
    )

    window.loadGtm?.()

    props.closeBanner()
  }

  const handleEssentialOnlyClick = () => {
    _wt({
      category: 'form',
      action: 'submit',
      values: [
        {
          type: 'cookie',
          value: policyOptions.essentials
        }
      ],
      location: 'banner-cookies'
    })

    window['🍪'].set(COOKIEPOLICYCONFIG, policyOptions.essentials, 3650)

    props.closeBanner()
  }

  useEffect(() => {
    _wt({
      category: 'banner',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'cookies'
        }
      ]
    })
  }, [])

  return (
    <div className='[ f-d-flc f-c-ba-pri800 f-c-fo-whi f-p-a-020 f-p-a-030:m ] Cookie-Banner'>
      <div className='[ f-t-mini f-t-bold f-p-b-010 ]'>
        Cookie-Einstellungen
      </div>
      <div className='[ f-t-micro f-m-a-0 ]'>
        Wir verwenden Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu
        bieten. Dazu zählen Cookies, die für den Betrieb der Seite und für die
        Steuerung unserer kommerziellen Unternehmensziele notwendig sind, sowie
        solche, die lediglich zu anonymen Statistikzwecken, für
        Komforteinstellungen oder zur Anzeige personalisierter Inhalte und
        personalisierter Werbung genutzt werden.
      </div>
      <div className='[ f-t-micro f-m-b-020 ]'>
        Sie können selbst entscheiden, welche Kategorien Sie zulassen möchten.
        Bitte beachten Sie, dass auf Basis Ihrer Einstellungen womöglich nicht
        mehr alle Funktionalitäten der Seite zur Verfügung stehen. Weitere
        Informationen finden Sie in unseren{' '}
        <CTA
          tag='a'
          type='text'
          target='_blank'
          href='/datenschutz/'
          style={{ textDecoration: 'underline' }}>
          Datenschutzhinweisen
        </CTA>
        .
      </div>
      <div className='Cookie-Banner__actions'>
        <CTA
          type='block-primary'
          tag='button'
          className='[ f-p-h-030 ] is-block'
          onClick={saveAll}
          wtData={{
            'CTA-click': {
              location: 'banner-cookies'
            }
          }}>
          Alle akzeptieren
        </CTA>
        <CTA
          type='block-tertiary'
          tag='button'
          className='[ f-t-body f-c-fo-whi f-p-h-030 ] is-block is-inverted'
          onClick={handleCookieModalOpen}
          wtData={{
            'CTA-click': {
              location: 'banner-cookies'
            }
          }}>
          Einstellungen
        </CTA>
        <CTA
          type='text'
          tag='button'
          className='[ f-t-body f-c-fo-whi ] is-block'
          onClick={handleEssentialOnlyClick}
          wtData={{
            'CTA-click': {
              location: 'banner-cookies',
              label: 'essential-only'
            }
          }}>
          Nur notwendige Cookies
        </CTA>
      </div>
    </div>
  )
}

export default CookieBanner
